"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

function TimelineCardSkeleton() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      loadingMessage = _ref.loadingMessage;

  return _react.default.createElement(_UICardWrapper.default, {
    compact: true
  }, _react.default.createElement(_UIFlex.default, {
    align: "center",
    justify: "center",
    direction: "column",
    className: "p-y-15"
  }, _react.default.createElement(_UILoadingSpinner.default, null), loadingMessage && _react.default.createElement(_FormattedHTMLMessage.default, {
    message: loadingMessage
  })));
}

var _default = TimelineCardSkeleton;
exports.default = _default;
module.exports = exports.default;